export default {"src":"/_next/static/media/lettuce.60551afa.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};